export const TABLE_SURFACES = {
  leadsActive: "leads_active",
  leadsInactive: "leads_inactive",
  projects: "projects",
  customers: "customers",
  subcontractors: "subcontractors",
  teamMembers: "team_members",
  milestones: "milestones",
  financialSummary: "financial_summary",
  invoices: "invoices",
  suppliers: "suppliers",
  reports: "reports",
  accountDeletionRequests: "account_deletion_requests",
  projectTypeTemplates: "project_type_templates",
  projectInvoices: "project_invoices",
  projectCommissions: "project_commissions",
  projectChecklists: "project_checklists",
  projectFinance: "project_finance",
  milestoneFinanceItems: "milestone_finance_items",
  paymentsHistory: "payments_history",
  dashboardNewLeads: "dashboard_new_leads",
  dashboardRecentProjects: "dashboard_recent_projects",
  invoiceDeliveryHistory: "invoice_delivery_history",
  financialSnapshot: "financial_snapshot_rows",
  leadsApproval: "leads_approval",
  dashboardTemplates: "dashboard_templates",
  leadChecklistEdit: "lead_checklist_edit",
  leadChecklistView: "lead_checklist_view"
} as const

export const DEFAULT_TAB = "default"
